module.exports = "/shared/fonts/Futura/web/FtraMd-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/ui/fonts/Futura/web/FtraMd-webfont.woff2
// module id = 33
// module chunks = 13